import $ from 'jquery';

$.fn.extend( {
	getPath: function () {
		var path, node = this;
		while ( node.length ) {
			var realNode = node[0], name = realNode.nodeName;
			if ( ! name ) {
				break;
			}

			name = name.toLowerCase();

			var parent = node.parent();

			var sameTagSiblings = parent.children( name );
			if ( sameTagSiblings.length ) {
				var allSiblings = parent.children();
				var index = allSiblings.index( realNode ) + 1;
				if ( index > 1 ) {
					name += ':nth-child(' + index + ')';
				}
			}

			path = name + ( path ? '>' + path : '' );
			node = parent;
		}

		return path;
	}
} );

/**
 * Used to attach to a element to always watch if its in the viewport.
 *
 * When scrolling, if element is in viewport add a parameter, a data attribute and a class name.
 */
export class InViewportAnimation {
	_elements;

	constructor() {
		this.boundScrollEvent = false;
		this.elements = {};
		this.selectors = '';

		const that = this;
		const body = $( 'body' );
		const relatedPostSelector = '.ebayads-related-posts-wrap > h6, .ebayads-related-post';

		let selectors = '#colophon';
		if ( body.hasClass( 'single-post' ) ) {
			selectors += ', .ebayads-arrow-link-wrap, .entry-title, .entry-content, .entry-footer *, .ebayads-related-posts-wrap, ' + relatedPostSelector;
		}

		if ( body.hasClass( 'single-release_notes' ) ) {
			selectors += ', .ebayads-arrow-link-wrap, .entry-title, .entry-content, .entry-footer *, .ebayads-related-posts-wrap, ' + relatedPostSelector;
		}

		if ( body.hasClass( 'single-events' ) ) {
			selectors += ', .ebayads-arrow-link-wrap, .entry-title, .entry-content, .entry-footer *, .ebayads-related-posts-wrap, ' + relatedPostSelector;
		}

		if ( body.hasClass( 'blog' ) || ( body.hasClass( 'archive' ) && body.hasClass( 'category' ) ) ) {
			selectors += ', .page-title, .archive-description, .ebayads-filter, article, .cta-block';
		}

		if ( body.hasClass( 'post-type-archive-stories' ) || body.hasClass( 'tax-goal' ) ) {
			selectors += ', #infinite_scroll_content .article-left-section, #infinite_scroll_content .cta-block, #infinite_scroll_content .row article, .article-right-section';
		}

		if ( body.hasClass( 'single-stories' ) ) {
			selectors += ', .ebayads-arrow-link-wrap, .page-title, .entry-content, .post-statistics *, .ebayads-social-share-wrap, .page-header_info-box .entry-footer *, .entry-footer-link';
		}

		if ( body.hasClass( 'post-type-archive-audiences' ) ) {
			selectors += ', .page-title, .archive-description, .archive-sub-text, .button-filters, .text-carousel-wrap, .cta-block';
		}

		if ( body.hasClass( 'single-audiences' ) ) {
			selectors += ', .ebayads-arrow-link-wrap, .main-heading, .sub-heading, .page-header-description, .print-btn, .featured-image, .image-text-column__heading, .block-cta-basic, .ebayads-list-block';
			selectors += ', .cta-block, ' + relatedPostSelector;
			selectors += ', .ebayads-block-content .wp-block-column h2, .ebayads-block-content .wp-block-column h3, .ebayads-block-content .wp-block-column h6, .ebayads-block-content .wp-block-column p, .ebayads-block-content .wp-block-column img';
		}

		if ( body.hasClass( 'page-template-ad-solutions' ) ) {
			selectors += ', .row, .cta-block, .page-header, .wp-block-columns, .ebayads-cover-background-block, ' + relatedPostSelector;
		}

		if ( body.hasClass( 'page-template-solution-providers' ) ) {
			selectors += ', .row, .cta-block, .page-header, .wp-block-columns, .ebayads-cover-background-block, ' + relatedPostSelector;
		}

		if ( body.hasClass( 'page-template-resources' ) ) {
			selectors += ', .row, .cta-block, .page-header, .wp-block-columns, .ebayads-cover-background-block, ' + relatedPostSelector;
		}

		if ( body.hasClass( 'page-template-general' ) ) {
			selectors += ', .page-header *, .page-content *';
		}

		if ( body.hasClass( 'page-template-ad-policies' ) ) {
			selectors += ', .page-content, .page-header h1, .page-header h5, .page-header p, .page-content h3, .page-content h4, .page-content h6, .page-content p, .page-content h3, .page-content li';
		}

		if ( body.hasClass( 'page-template-faq' ) ) {
			selectors += ', .entry-title, .page-content button, .qna-list';
		}

		if ( body.hasClass( 'home' ) ) {
			selectors += ', .front-video-block, .text-img-col-type-one, .ebayads-image, .grp-img-text-col, .text-img-col-heading-default, .animated-stats-col, .left-aligned-img-template__img, .text-img-col-type-two, .related-posts-info, .related-posts-carousel-wrap, .wp-block-ebayads-blocks-cta';
		}

		if ( body.hasClass( 'page' ) ) {
			selectors += ', .about-full-size-image, .about-heading-txt, .group-text-col-heading, .group-text-column .wp-block-group, .about-icons-gallery__heading, .ebayads-logo-gallery, .wp-block-buttons, .ebayads-time-zones__inner';
		}

		that.selectors = selectors;
		that.scroll();
		that.checkElements();
		that.toggleClasses();
	}

	addElement( element ) {
		if ( $( element ).length ) {
			if ( 'undefined' !== typeof this.elements[ $( element ).getPath() ] ) {
				return;
			}

			$( element ).toggleClass( 'initiate-scroll-animation', true );
			this.elements[ $( element ).getPath() ] = element;
		}
	}

	setClasses( elem ) {
		const inViewport = this.inViewport( elem );
		elem.inViewport = inViewport;
		elem.attr( 'data-in-viewport', inViewport ).toggleClass( 'in-viewport', inViewport );

		this.setInlineClasses( inViewport, elem );
	}

	setInlineClasses( inViewport, elem ) {
		if ( ! inViewport ) {
			elem.css( { opacity: '0.5', transform: 'translateY(15px)', transition: '1s transform ease, 1s opacity ease' } );
		} else {
			elem.css( { opacity: '1', transform: 'translateY(0)', transition: '1s transform ease, 1s opacity ease' } );
		}
	}

	checkElements() {
		$( this.selectors ).each( ( i, elem ) => {
			this.addElement( elem );
		} );
	}

	scroll() {
		if ( ! this.boundScrollEvent ) {
			$( window ).on( 'scroll', () => {
				this.checkElements();
				this.toggleClasses();
			} );
			this.boundScrollEvent = true;
		}
	}

	toggleClasses( elem = false ) {
		if ( ! elem ) {
			if ( ! Object.keys( this.elements ).length ) {
				return;
			}

			Object.keys( this.elements ).forEach( ( path ) => {
				if ( 'skip' === this.elements[ path ] ) {
					return;
				}

				const elem = $( this.elements[ path ] );
				const inViewport = this.inViewport( elem );
				elem.inViewport = inViewport;
				elem.attr( 'data-in-viewport', inViewport ).toggleClass( 'in-viewport', inViewport );

				this.setInlineClasses( inViewport, elem );

				if ( inViewport ) {
					this.elements[ path ] = 'skip';
				}
			} );
		} else {
			const inViewport = this.inViewport( elem );
			elem.inViewport = inViewport;
			elem.attr( 'data-in-viewport', inViewport ).toggleClass( 'in-viewport', inViewport );

			this.setInlineClasses( inViewport, elem );
		}
	}

	inViewport( elem ) {
		return this.elementBottom( elem ) > this.viewportTop() && this.elementTop( elem ) < this.viewportBottom();
	}

	elementBottom( elem ) {
		return this.elementTop( elem ) + $( elem ).outerHeight();
	}

	viewportTop() {
		return $( window ).scrollTop();
	}

	elementTop( elem ) {
		return $( elem ).offset().top;
	}

	viewportBottom() {
		return this.viewportTop() + $( window ).height();
	}
}
